import { render, staticRenderFns } from "./date-range-picker.component.vue?vue&type=template&id=37b19ff4&scoped=true"
import script from "./date-range-picker.component.vue?vue&type=script&lang=ts"
export * from "./date-range-picker.component.vue?vue&type=script&lang=ts"
import style0 from "./date-range-picker.component.vue?vue&type=style&index=0&id=37b19ff4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b19ff4",
  null
  
)

export default component.exports